import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { ProjectSubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/project-sub-product-updater/index.tsx';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { usePathParam } from '@atlassian/react-resource-router';
import { ServiceDeskIncidentManagementSettings } from './ui';

const METRICS_PAGE_ID = 'service-desk-incident-management-settings';
const COMPONENT_NAME = 'incidentManagementSettings';

export const ServiceDeskIncidentManagementSettingsPage = () => {
	const [projectKey = ''] = usePathParam('projectKey');
	return (
		<>
			<MarkProductStart />
			<ProjectSettingsController projectKey={projectKey}>
				<JSErrorBoundary
					id={METRICS_PAGE_ID}
					packageName="jiraSpaAppsProjectSettings"
					teamName="itsm-agni"
				>
					<ProjectSubProductUpdater />
					<ThemeProvider theme={{}}>
						<ContextualAnalyticsData sourceType={SCREEN} sourceName={COMPONENT_NAME}>
							<ServiceDeskAnalyticsContext>
								<ServiceDeskIncidentManagementSettings />
							</ServiceDeskAnalyticsContext>
						</ContextualAnalyticsData>
					</ThemeProvider>
				</JSErrorBoundary>
			</ProjectSettingsController>
		</>
	);
};

export default ServiceDeskIncidentManagementSettingsPage;
